import { chatSocketUrl } from '@/utils/chatState'

export const useChatRealtime = onChange => {
  const status = ref('connecting')
  const session = useAuthSession()
  const config = useRuntimeConfig()
  let client
  let stopped = false
  let generation = 0
  const start = async () => {
    const version = ++generation
    stopped = false
    await client?.deactivate()
    let Client
    try { ({ Client } = await import('@stomp/stompjs')) }
    catch (error) {
      if (version === generation && !stopped) status.value = 'periodic'
      throw error
    }
    if (stopped || version !== generation) return
    const socket = new Client({
      brokerURL: chatSocketUrl(config.public.apiBaseUrl, window.location.origin),
      reconnectDelay: 4000, connectionTimeout: 10000,
      heartbeatIncoming: 15000, heartbeatOutgoing: 10000,
      debug: () => {}, // Never log authentication headers or private messages.
      beforeConnect: async () => {
        await session.ensure()
        const token = session.read()?.token
        if (stopped || version !== generation || !token) { await socket.deactivate(); return }
        status.value = 'connecting'
        socket.connectHeaders = { Authorization: `Bearer ${token}` }
      },
      onConnect: () => {
        if (stopped || version !== generation) { void socket.deactivate(); return }
        status.value = 'connected'
        socket.subscribe('/user/queue/chat', () => onChange())
        onChange() // Recover events missed before subscription or while disconnected.
      },
      onWebSocketClose: () => { if (version === generation) status.value = 'periodic' },
      onStompError: () => { if (version === generation) status.value = 'periodic' },
      onWebSocketError: () => { if (version === generation) status.value = 'periodic' },
    })
    client = socket
    socket.activate()
  }
  const stop = () => { generation++; stopped = true; void client?.deactivate(); status.value = 'periodic' }
  onBeforeUnmount(stop)
  return { status, start, stop }
}
